﻿import $ from 'jquery'

export class FormValidation {
  public static get validationClass(): string {
    return 'input-validation-error';
  }

  private static handlers: Array<IValidationHandler> = new Array<IValidationHandler>();
  public static registerHandler(...handlers: IValidationHandler[]): void {
    handlers.forEach(function (handler) {
      FormValidation.handlers.push(handler);
    });
  }
  static handleErrors(): void {
    var _this = this;
    var $errors = $('.field-validation-error');
    if ($errors.length == 0)
      return;

    $errors.each(function () {
      var $error = $(this);

      for (var i = 0; i < _this.handlers.length; i++) {
        var isHandled = _this.handlers[i].handle($error);
        if (isHandled)
          break;
      }
    });

    $(document).trigger('formvalidationhandled.rustig.formvalidation');
  }
}

export interface IValidationHandler {
  handle($error: JQuery): boolean;
}
